import angular from "angular";
import ngAnimate from "angular-animate";
import ngSanitize from "angular-sanitize";
import ngTouch from "angular-touch";

export default angular.module("controllers.metricsReport", [
  ngAnimate,
  ngSanitize,
  ngTouch,
])
  .controller("MetricsReportController", [
    function() {
      this.showPrices = false;
      this.showDeadlines = false;

      this.togglePrices = function() {
        this.showPrices = !this.showPrices;
      };

      this.toggleDeadlines = function() {
        this.showDeadlines = !this.showDeadlines;
      };
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/metrics-report-controller.js